import { ReactComponent as DocumentWordIcon } from '@Icons/additional/software-logo/logo-brand-word.svg';
import { ReactComponent as DocumentExcelIcon } from '@Icons/additional/software-logo/logo-brand-excel.svg';
import { ReactComponent as DocumentPowerpointIcon } from '@Icons/additional/software-logo/logo-brand-powerpoint.svg';
import { ReactComponent as DocumentSVGIcon } from '@Icons/additional/software-logo/logo-SVG.svg';
import { ReactComponent as DocumentJPGIcon } from '@Icons/additional/software-logo/logo-JPG.svg';
import { ReactComponent as DocumentPNGIcon } from '@Icons/additional/software-logo/logo-PNG.svg';
import { ReactComponent as DocumentPDFIcon } from '@Icons/additional/software-logo/logo-pdf.svg';

interface LogoTypeProps {
  fileExt?: string;
}

interface MapLogos {
  [key: string]: JSX.Element;
}

const mapLogos: MapLogos = {
  png: <DocumentPNGIcon />,
  jpg: <DocumentJPGIcon />,
  svg: <DocumentSVGIcon />,
  doc: <DocumentWordIcon />,
  pdf: <DocumentPDFIcon />,
  excel: <DocumentExcelIcon />,
  pptx: <DocumentPowerpointIcon />,
};

const LogoType: React.FC<LogoTypeProps> = ({ fileExt = 'doc' }) => {
  const filetype = fileExt.toLocaleLowerCase();

  return mapLogos[filetype];
};
export default LogoType;
